/**
 * Web vitals reporting utility
 * 
 * @author Claude
 */
import { ReportHandler } from 'web-vitals';

/**
 * Report web vitals metrics
 * @param {ReportHandler} onPerfEntry - Performance entry callback
 */
const reportWebVitals = (onPerfEntry?: ReportHandler): void => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFID(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;